import React,{useState,useEffect} from "react";
/*  import useSelector to fetch data from global  redux store  */

//import KnowledgeCube from "../img/knowledgecube.gif";
import closeIcon from "../icons/close_FILL0_wght200_GRAD-25_opsz40.svg";

import leftOpen from "../icons/fullscreen_FILL0_wght200_GRAD0_opsz40.svg";
//import { useSelector } from "react-redux";
  import { useRouteMatch,Switch, Route } from "react-router-dom";

  import { useDispatch,useSelector } from 'react-redux';
  
import Loading from "../Loading/Loading"; 

import loadable from '@loadable/component';
import SettingsCourseCardFeatures from "../Create/CreateCourse/SettingsCourseCardFeatures";
import SettingsCoursePageFeatures from "../Create/CreateCourse/SettingsCoursePageFeatures";
import CreateContent from "../Create/CreateContent";
// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;const Profile = loadable(() => import("./Profile/Profile"), {
    fallback: lazyLoad  });

    
    const CreateCourse = loadable(() => import("../Create/CreateCourse"), {
      fallback: lazyLoad  });

      const MyEnrollments = loadable(() => import("./MyEnrollment/MyEnrollments"), {
        fallback: lazyLoad  });

const SkillReport = loadable(() => import("./SkillReport/SkillReport"), {
  fallback: lazyLoad  });
  const StudyPlan = loadable(() => import("./StudyPlan/StudyPlan"), {
    fallback: lazyLoad  });
    
const Navber = loadable(() => import("../../Navbar/UserMenu"), {
  fallback: lazyLoad  });

  
 const Dashboard = ()=>{
      const {url}=useRouteMatch();
      const [open , setOpen]=useState(false);
   // const userdata = useSelector((state)=>state?.user?.user?.user);
   const dispatch = useDispatch();
    
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
 
  useEffect(() => {
    setOpen(false) 
  }, []);
 
  


    return <>

<div className={`${mainMenuStatus?"outer-all ":"outer-all-small"} ` } style={{zIndex:"99",marginTop:"-20px"}} >
  <div></div>
<div className = {` outer-left ${open?"outer-left-style":"outer-right-style"} `}style={{zIndex:"99"}}   id="outer-left">
  
<div className="">
       
{
              open?
              <div className="outer-left-close" style={{marginTop:"-20px"}} onClick={()=>setOpen(false)}><img src={closeIcon} alt="left-close" /></div>
                :
            ""
              }
              
 
       <Navber/>
    </div>
    
    
    </div>
    <div className="outer-right">
        <div className="content-topk">
              <div className="">
             
        
        
                
                {
              open?
             ""   :
            <div className=" outer-left-open" onClick={()=>setOpen(true)}>
                            <img src={leftOpen} alt="left Open"/></div>
              }
             </div>
           </div> 

    








<Switch>
    <Route exact path={`${url}/`}>
<div> Dashboard</div>
    </Route>
<Route path={`${url}/profile`}>
    
<Profile baseUrl={url}/>
</Route>

<Route path={`${url}/enrolments`}>
    
  <div> Enrollments </div>
  <MyEnrollments/>
    </Route>
    
 
      
    
    <Route path={`${url}/skill-report`}>
    
    <div> Skill Report </div>
    <SkillReport/>
      </Route>
      <Route path={`${url}/study-plan`}>
    
    <div> Study Plan </div>
    <StudyPlan/> 
      </Route>

      
      <Route path={`${url}/create-course`}>
    
    <CreateCourse/> 
      </Route> <Route path={`${url}/create-content`}>
    
    <CreateContent/> 
      </Route>
    
      <Route path={`${currentToken?"/dashboard/course-page-features/":
      "/course-page-features/"}`}>
    
    <SettingsCoursePageFeatures />
    </Route>
    <Route path={`${currentToken?"/dashboard/course-card-features/":
      "/course-card-features/"}`}>
    
    <SettingsCourseCardFeatures/>
    </Route>

     
</Switch>
       
        

       
       
            
                
                <div className="content-bottom">

        </div>
    </div>
</div>
   
    </>

}
export default Dashboard;
